import { Chip } from '@mui/material';

import { enumToCamelCase } from 'src/lib/formatters';

export const ProductStatusChip = ({ status }: { status: string }) => {
    let color;
    switch (status) {
        case 'ACTIVE':
            color = 'success';
            break;
        case 'DEACTIVATED':
            color = 'error';
            break;
        default:
            color = 'primary';
            break;
    }

    return (
        <Chip
            label={enumToCamelCase(status)}
            variant="outlined"
            color={color}
            sx={{
                height: '24px',
            }}
        />
    );
};
